<template>
	<div class="language" :class="{ visible: visible }">
		
		<div class="langs">
			<v-touch @tap="set_lang('en')" class="lang" :class="{ active: my_lang == 'en' }">English</v-touch>
			<v-touch @tap="set_lang('fr')" class="lang" :class="{ active: my_lang == 'fr' }">Français</v-touch>
		</div>

		<div class="buttons">
			<v-touch @tap="end_lang()" class="button" :class="position">
				<span class="arrow"><icon file="up-triangle" /></span>
				<span v-show="!my_lang" class="question">?</span>
				<span v-show="my_lang == 'en'">Start</span>
				<span v-show="my_lang == 'fr'">Lancer</span>
			</v-touch>
		</div>

	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'Language',
	data () {
		return {
			my_lang: '',
			position: '',
			visible: false
		}
	},
	computed: Object.assign(mapGetters([ 'app', 'lang' ]), {
		
	}),
	methods: {
		set_lang: function(lang) {
			this.$store.commit('EDIT_USER', { lang: lang })
			this.my_lang = lang
			if (lang == 'en') this.position = 'left'
			if (lang == 'fr') this.position = 'right'
			sounds.play('tap')
		},
		end_lang: function(lang) {
			if (this.my_lang) {
				this.$store.commit('EDIT_FIRST_TIMES', { lang: false })
				this.$store.dispatch('save_data')
				this.$store.dispatch('start_game')
				sounds.play('tap')
			}
		}
	},
	mounted: function() {
		this.$nextTick(function() {
			this.visible = true
		})
	}
}
</script>

<style lang="stylus">
@import '../assets/css/app'

.language
	position absolute
	left 0
	top 0
	right 0
	bottom 0
	background dark
	display flex
	align-items center
	justify-content center
	align-content center
	flex-direction column
	font-size 24px
	color #fff
	opacity 0
	&.visible
		opacity 1
	.langs
		.lang
			display inline-block
			padding 16px
			color lighten(dark, 75%)
			&.active
				color green
	.buttons
		margin 8px 0 0 0
		.button
			width 120px
			height 120px
			background green
			border-radius 100%
			text-align center
			line-height @height
			font-size 24px
			transition 0.5s easeOutQuart
			background darken(dark, 10%)
			color #fff
			&.left
				background green
				.arrow
					transform rotate(-30deg)
					color green
			&.right
				background green
				.arrow
					transform rotate(30deg)
					color green
			.arrow
				position absolute
				top -16px
				left calc(50% - 12px)
				transform-origin 12px (60px + 16px)
				transition 0.5s easeOutQuart
				color darken(dark, 10%)
				.icon
					display block
			.question
				color dark
				font-size 40px
				

			

</style>



// WEBPACK FOOTER //
// src/components/Language.vue